import { onBeforeUnmount, onMounted, ref } from 'vue';

/**
 * Computes the position for the teleported panel relative to the trigger
 * and refreshes it on scroll/resize while open. Initial style positions the
 * panel off-screen so the first render never lays out in document flow.
 *
 * @param {import('vue').Ref<HTMLElement|null>} triggerRef
 * @param {import('vue').Ref<boolean>} open
 */
export function usePanelPosition(triggerRef, open) {
    const panelStyle = ref({
        position: 'fixed',
        top: '-9999px',
        left: '-9999px',
    });

    function updatePanelPosition() {
        if (!open.value || !triggerRef.value) return;
        const rect = triggerRef.value.getBoundingClientRect();
        panelStyle.value = {
            position: 'fixed',
            top: `${rect.bottom + 4}px`,
            left: `${rect.left}px`,
            width: `${rect.width}px`,
            zIndex: 1000,
        };
    }

    function onViewportChange() {
        if (!open.value) return;
        updatePanelPosition();
    }

    onMounted(() => {
        window.addEventListener('scroll', onViewportChange, true);
        window.addEventListener('resize', onViewportChange);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('scroll', onViewportChange, true);
        window.removeEventListener('resize', onViewportChange);
    });

    return { panelStyle, updatePanelPosition };
}
